/**
 * Alimentos Mary's on-screen words. Mary is the base: these are exactly the texts the admin
 * showed before the company layer, and every other company falls back to them for a key it
 * does not define (see `company/labels.js`).
 */
const MARY_LABELS = Object.freeze({
    // The `promotor` role (role values, API fields and routes keep `promotor`)
    promotor: 'Promotor',
    promotores: 'Promotores',
    promotorLower: 'promotor',
    promotoresLower: 'promotores',
    // The company's own brand on shelf (Mary's catalog also has the Caledonia line)
    ownBrand: 'Mary',
    ownBrandFaces: 'Caras Mary',
    ownBrandFacesPercent: 'Porcentaje Caras Mary',
    ownBrandProduct: 'producto Mary',
    // Screen names that carry the brand or Mary's own wording
    navDistributorPrices: 'Levantamiento Mary',
    navPolls: 'Evaluación FFVV Indirecta',
    pollsTitle: 'Evaluación FFVV Indirecta',
    pollsDescription: 'Resultados de la evaluación de la FFVV indirecta',
    navPollsDescription: 'Evaluación de la FFVV indirecta',
    // Permissions console: what permissions do not change
    permissionsScopeNote:
        'Los permisos definen pantallas y funciones; el alcance de datos sigue fijo por rol (asesor → sus clientes, asesor/gerente → su región en Levantamiento, Análisis Auditor → solo registros de auditores).',
});

export default MARY_LABELS;
